module.exports = __webpack_public_path__ + "static/media/create-feature-dis-wc.9f8ea819.svg";